import Request from "../../lib/request";
import { PAGE, PROJECT_USER_ID } from "../../constants/filters";
import {
  CLASSIFIED_EXPENDITURES_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${CLASSIFIED_EXPENDITURES_API}?${PAGE}=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};
